module.exports = __webpack_public_path__ + "img/MoonSword 1.d146d2b4.png";